riot.tag2('layout-menu', '<a class="btn-floating btn-large waves-effect red button-collapse top-nav waves-effect waves-light hide-on-large-only" data-activates="nav-mobile" id="menu-button">menu</a><ul class="side-nav fixed" id="nav-mobile"><li class="logo"><a class="brand-logo" href="?#" id="logo-container"><img class="z-depth-2" id="front-page-logo" src="images/acsin14-mini.jpg" width="170"></a></li><li class="bold {selected:menu[3]}" each="{menu in menus}"><a class="waves-effect waves-teal" href="{menu[0]}">{menu[1]}</a><ul if="{menu[2]}"><li each="{sub in menu[2]}"><a class="waves-effect waves-teal" href="{sub[0]}">{sub[1]}</a></li></ul></li></ul>', '#logo-container{height:180px;padding-top:20px;text-align:center;background-color:#5F83BB}#nav-mobile>li>ul{padding-left:20px}ul.side-nav.fixed{overflow:auto;height:100vh;box-shadow:none;background-color:#c3dbf9;width:250px}ul.side-nav.fixed a{height:40px;line-height:40px}ul.side-nav.fixed li a{height:36px;line-height:36px}#nav-mobile .selected{border-right:solid 4px orange}#nav-mobile a.active{position:relative}#nav-mobile a.active::after{display:block;width:0;height:0;border-right:10px solid orange;border-left:10px solid transparent;border-top:10px solid transparent;border-bottom:10px solid transparent;right:0px;top:8px;position:absolute;box-sizing:content-box;content:""}#menu-button{position:fixed;left:10px;top:10px;opacity:.6;transition:opacity .3s ease-in-out;z-index:200}#menu-button:hover{opacity:1}#nav-mobile-note{position:relative}', '', function(opts) {
(function() {
  var buildToc;

  this.menus = [["?#", "Home", [["?#online-abstract", "Online Abstract"], ["?#important-dates", "Important Dates"], ["?#correspondence", "Correspondence"]]], ["?program", "Program", [["?program#time-table", "Time Table"], ["?program#plenary-lectures", "Plenary Lectures"], ["?program#invited-speakers", "Invited Speakers"], ["?program#oral-presentation", "Presentation Guide"]]], ["?registration", "Abstract/Registration/Hotels", [["?registration#registration-fees", "Registration Fees"], ["?registration#hotels", "Hotels"], ["?registration#abstract-format", "Abstract Format"], ["?registration#registration-site", "Registration Site"]]], ["?awards", "Awards", []], ["?proceedings", "Proceedings", []], ["?venue", "Conference Venue", [['?venue#visas', 'Visas']]]];

  buildToc = (function(_this) {
    return function() {
      var page;
      page = location.search || '?';
      _this.menus.forEach(function(m) {
        if (m[0].split('#')[0] !== page) {
          return m[3] = "";
        } else {
          m[3] = "selected";
          m[2] = [];
          return $(".section.scrollspy[id]").each(function() {
            return m[2].push(["#" + this.id, $("h1,h2,h3,h4,h5", this)[0].innerText]);
          });
        }
      });
      return _this.update();
    };
  })(this);

  this.on("mount", function() {
    buildToc();
    $('.scrollspy').scrollSpy({
      scrollOffset: 0
    });
    $('#menu-button').sideNav();
    return setTimeout(function() {
      return $('#menu-button').css({
        'transition': 'transition',
        'none': 'none'
      }).delay(1000).animate({
        width: '100px',
        height: '100px',
        opacity: '1.0',
        lineHeight: '98px',
        fontSize: '25px'
      }, 'slow', 'easeOutExpo').animate({
        width: '56px',
        height: '56px',
        opacity: '0.6',
        lineHeight: '54px',
        fontSize: '14px'
      }, 2000, 'easeOutBounce').queue(function() {
        return $('#menu-button').removeAttr('style');
      });
    });
  });

}).call(this);
});



//////////////////
// WEBPACK FOOTER
// ./src/scripts/layout-menu.tag.slim
// module id = 48
// module chunks = 0